import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'app/store/store'
import { IPaymentSchedule, IPaymentScheduleState } from './types/PaymentShedule-interface'

const PaymentSheduleState = (state: RootState): IPaymentScheduleState => state.contractPaymentShedule

export const PaymentShedule = createSelector(
    [PaymentSheduleState],
    (state): IPaymentSchedule[] => state.paymentSchedule,
)
export const LoadingPaymentShedule = createSelector(
    [PaymentSheduleState],
    (state): boolean => state.isLoadingPaymentSchedule,
)
export const ErrorPaymentShedule = createSelector(
    [PaymentSheduleState],
    (state): string[] => state.errorPaymentSchedule,
)

export const LastFetchPaymentShedule = createSelector(
    [PaymentSheduleState],
    (state): null | number => state.lastFetchTime,
)
export const IdCasePaymentShedule = createSelector(
    [PaymentSheduleState],
    (state):  null | string => state.idCase,
)